// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumberInput_container__jNmoj","wi":"PhoneNumberInput_wi__SxaEC","iconContainer":"PhoneNumberInput_iconContainer__lmONP"};